module.exports = __webpack_public_path__ + "static/believe-1a4a32d8c6143dd182e58b1dd270bbd1.png";